import { generateFinalUrl } from "../../shared/helpers";
import { TAL_AUTO_SUGGESTED } from "../../shared/constants";

export const dedupeById = (items = []) => {
  const seen = {};

  return items.filter((item) => {
    if (!seen[item._id]) {
      seen[item._id] = true;
      return true;
    }

    return false;
  });
};

export const getTopSkills = (skills = []) => {
  if (!Array.isArray(skills) || skills.length === 0) return [];

  return [...skills]
    .sort((a, b) => (b?.SkillPercent || 0) - (a?.SkillPercent || 0))
    .slice(0, 3)
    .map((skill) => ({
      id: skill?.Skills?.SkillName,
      name: skill?.Skills?.SkillName,
    }))
    .filter((item) => item.id && item.name);
};

const normalizeStatusTitle = (title = "") =>
  String(title)
    .toLowerCase()
    .replace(/[^a-z]/g, "");

export const getGigStatusCount = (statuses = [], matcher = () => false) => {
  if (!Array.isArray(statuses)) return 0;

  const match = statuses.find((status) => matcher(normalizeStatusTitle(status?.title)));
  return match?.count || 0;
};

const getArrayObject = (name = "", id = "") => [{ name, id }];

export const buildAISuggestionQuery = ({ regions, countries, cities, skills = [] }) => {
  const accumulatedFilters = {};

  const addFilterToUrl = (key, value) => {
    if (value !== undefined && value !== null) {
      const encodedValue =
        typeof value === "string" || typeof value === "number"
          ? String(value).replace(/&/g, "-*")
          : JSON.stringify(value).replace(/&/g, "-*");

      accumulatedFilters[key] = encodedValue;
    }
  };

  const checkRadioRegion = regions
    ? getArrayObject(regions?.RegionName, regions?.RegionId)
    : undefined;
  const checkRegionId = regions ? [regions?.RegionId] : undefined;

  const checkRadioCountry = countries
    ? getArrayObject(countries?.CountryName, countries?.CountryId)
    : undefined;
  const checkCountryId = countries ? [countries?.CountryId] : undefined;

  const checkRadioLoc = cities ? getArrayObject(cities?.Location, cities?.CityId) : undefined;
  const checkCityId = cities ? [cities?.CityId] : undefined;

  const checkRadioSkill = getTopSkills(skills);
  const checkSkillId = checkRadioSkill.map((item) => item.name);
  const skillsPercentages = [...skills]
    .sort((a, b) => (b?.SkillPercent || 0) - (a?.SkillPercent || 0))
    .slice(0, 3)
    .map((item) => item?.SkillPercent);

  [
    { key: "Region", value: checkRadioRegion },
    { key: "regionId", value: checkRegionId },
    { key: "Country", value: checkRadioCountry },
    { key: "countryId", value: checkCountryId },
    { key: "City", value: checkRadioLoc },
    { key: "cityId", value: checkCityId },
    { key: "Skill", value: checkRadioSkill },
    { key: "skillsId", value: checkSkillId },
    { key: "skillsPercentages", value: skillsPercentages },
    { key: "searchType", value: TAL_AUTO_SUGGESTED },
    { key: "isTalentSuggestion", value: true },
  ].forEach((item) => addFilterToUrl(item.key, item.value));

  return generateFinalUrl("/query", accumulatedFilters);
};
